<template>
    <div class="m-t-2 text-center">
        <div v-if=" ! infoMessage && ! filePath">
            <button v-on:click="showModal" type="button" class="btn btn-outline btn-outline--bright btn-icon m-b-4">
                <span class="icon i-container i-filled-accent">
                    <!-- /icons/upload.svg -->
                    <svg class="i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11 7.4V16h2V7.4l4 4 1.4-1.4-5.7-5.7c-.4-.4-1-.4-1.4 0L5.6 10 7 11.4l4-4zM5 18h14v2H5z" class="icon"/></svg>
                </span>
                {{ trans('Upload CSV File') }}
            </button>
            <p class="c-muted f-s-2">{{ trans('Format your CSV file by First Name, Last Name, Email Address and Password (4 columns)') }}</p>
        </div>
        <div v-else>
            <div class="m-t-2 text-center">
                <span class="i-container i-filled-accent m-r-2">
                    <!-- /icons/file.svg -->
                    <svg class="icon i-size-medium" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M31 0H1C.4 0 0 .4 0 1v30c0 .6.4 1 1 1h30c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 30H2V2h28v28z"/><path d="M8 17h16c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm0-7h16c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm0 14h16c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1z"/></g></svg>
                </span>
                <div class="c-muted f-s-4 inline m-r-4">
                    {{ infoMessage }}
                </div>
                <button v-on:click="removeFile" type="button" class="btn btn-text btn-text--muted width-auto-min">{{ trans('Remove') }}</button>
            </div>
        </div>

        <files-upload-modal
            accepted-file-types=".csv"
            v-bind:max-files-num="1"
            v-on:close="modal.show = false"
            v-on:add-files="addFiles"
            ref="files-upload-modal"
        ></files-upload-modal>

        <input type="hidden" v-bind:value="filePath" name="file" />
    </div>
</template>
<script>
import { EventBus } from '../event-bus.js';

export default {
    data() {
        return {
            modal: null,
            filePath: '',
            infoMessage: null
        }
    },
    watch: {
        filePath(path) {
            EventBus.$emit('form:element:changed', 'file', path);
        },
    },
    methods: {
        addFiles(files) {
            this.filePath = _.head(files).path;
            window.axios.put(Kourses.apiBaseUrl + '/members/import-csv', {
                'file_path': this.filePath
            }).then((response) => {
                this.modal.show = false;
                this.modal.saving = false;
                this.modal.files = [];
                this.infoMessage = _.get(response.data, 'records', 0) + this.trans(' member records found in given CSV file.');
                EventBus.$emit('removeAllFiles');
            }).catch(({response}) => {
                console.log(response);
            });
        },
        showModal() {
            this.modal.show = true;
        },
        removeFile() {
            this.filePath = '';
            this.infoMessage = null;
        }
    },
    mounted() {
        this.modal = this.$refs['files-upload-modal'];
    }
}
</script>